import axios from 'axios';

const getMenuItems = ({ callback, user, params }) => {
  // Retry mechanisme als token nog niet beschikbaar is
  const loadMenu = (retries = 3) => {
    if (!axios.defaults.headers.common['Authorization']) {
      if (retries > 0) {
        console.log(`Token not yet available, retrying in 1s... (${retries} attempts left)`);
        setTimeout(() => loadMenu(retries - 1), 1000);
        return;
      }
      console.warn('Token not available after retries, returning empty menu.');
      callback([]);
      return;
    }

    const GET_MENU = `{
      menuStructure{
        menuItems {
          text
          path
          icon
          children {
            text
            path
            icon
            children {
              text
              path
              icon 
            } 
          }
        }
      }
    }`;

    axios({
      url: process.env.REACT_APP_APOLLO_URL,
      method: 'post',
      data: { query: GET_MENU }
    })
    .then(x => {
      if (!x.data?.data?.menuStructure?.menuItems) {
        console.error('Invalid response from menu API:', x);
        callback([]);
        return;
      }
      
      const menuItems = x.data.data.menuStructure.menuItems;
    
    // menuItems.push({
    //   text: "i18n_menu_contracts",
    //   path: "/admin/contracts",
    //   icon: GavelIcon,
    // })
    // menuItems.push({
    //   text: "i18n_menu_organizationmanagement",
    //   path: "/admin/organizationmanagement/",
    //   icon: "Settings",
    // })
      callback(menuItems);
    })
    .catch(err => {
      console.error('Error loading menu items:', err);
      if (err.response?.status === 401) {
        delete axios.defaults.headers.common['Authorization'];
      }
      callback([]);
    });
  };

  loadMenu();
}

export default getMenuItems
